<template lang="pug">
  .appointments
    .background-header.white
      v-container.white(style="max-width:600px")
        v-layout
          h2.ml-2 Appointments
        v-layout.mt-2
          v-row(align="center")
            v-col.py-0.pl-4.pr-0
              v-text-field(v-model="searchText" prepend-inner-icon="mdi-file-search" label='Search Appointment' hide-details dense rounded outlined)
            v-col.py-0.shrink(v-if="member.role === 'Admin'")
              v-btn.text-capitalize.px-1.font-weight-bold(color='accent' style="letter-spacing: 0" text @click="clickAddAppointment")
                v-icon.ml-n1(small) mdi-plus
                | Appointments
    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="appointments.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption Appointments not found or empty
        template(v-else v-for="(appointment, index) in appointments")
          appointment-item(:key="appointment.id" :appointment="appointment" :company="company" @deleted="handleDeleteItem")
      div.mt-4
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
    .modals
      add-appointment(v-if="showAddAppointmentDialog" :open.sync="showAddAppointmentDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import AddAppointment from '@/components/dialogs/AddAppointment.vue'
import AppointmentItem from '@/components/AppointmentItem.vue'

export default {
  name: 'Appointments',
  components: { AddAppointment, AppointmentItem },
  props: ['company'],
  data: () => ({
    isFetching: false,
    showAddAppointmentDialog: false,
    appointments: [],
    pageSize: 10,
    page: 1,
    searchText: '',
    count: 0,
    searchCountDown: null,
  }),
  computed: {
    ...mapState('user', ['member']),
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchAppointments(1)
    } else {
      this.fetchAppointments(this.$route.query.page)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchAppointments(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchAppointments(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/appointment/appointments/?page=${page}&page_size=${this.pageSize}&company=${this.company.id}&ordering=order`
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.appointments = response.data.results
        this.count= response.data.count
      })
      .catch(() => {})
    },
    clickAddAppointment () {
      this.showAddAppointmentDialog = true
    },
    searchItem () {
      let searchUrl = searchUrl = `/appointment/appointments/?page=1&page_size=${this.pageSize}&company=${this.company.id}&ordering=-id&type_exclude=store`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.appointments = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.appointments = this.appointments.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.appointments.push(item)
    }
  }
}
</script>
